/**
 *
 * Settings
 *
 */

import React, { memo } from 'react';

import { Stack } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import { Card, PageHeaderWithIcon } from 'components/DataDisplay';
import { OrganizationIcon } from 'components/Icons';
import { usePageContentContext } from 'components/Layout';
import { OrganizationConfig } from 'containers/Settings/Components/OrganizationConfig';
import { useInjectReducer, useInjectSaga } from 'utils/redux-injectors';

import { settingsSaga } from './saga';
import { reducer, sliceKey } from './slice';

export const Settings = memo(() => {
  useInjectReducer({ key: sliceKey, reducer: reducer });
  useInjectSaga({ key: sliceKey, saga: settingsSaga });
  const { contentHeight } = usePageContentContext();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { t, i18n } = useTranslation();

  return (
    <Card styles={{ cardContent: { h: contentHeight + 'px' } }}>
      <Stack spacing={5}>
        <PageHeaderWithIcon
          label="Organization Settings"
          icon={<OrganizationIcon />}
          //fontWeight={600}
        />
        <OrganizationConfig />
      </Stack>
    </Card>
  );
});
